import { render, staticRenderFns } from "./ClickPurchaseModal.vue?vue&type=template&id=419ff2c5"
import script from "./ClickPurchaseModal.vue?vue&type=script&lang=js"
export * from "./ClickPurchaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports